const urlParams = new URLSearchParams(window.location.search);
const hydrationScore = parseFloat(urlParams.get('hydrationScore')) || 0;
const foodIntake = parseFloat(urlParams.get('foodIntake')) || 0;
const waterIntake = parseFloat(urlParams.get('waterIntake')) || 0;

document.addEventListener('DOMContentLoaded', function () {
  document.getElementById('hydration-score').textContent = hydrationScore.toFixed(1);
  document.getElementById('food-intake').textContent = foodIntake.toFixed(2);
  document.getElementById('water-intake').textContent = waterIntake.toFixed(2);
  const wrapper = document.querySelector('.video-wrapper');
  const iframe = wrapper ? wrapper.querySelector('iframe') : null;
  if (!iframe || !iframe.src || !iframe.src.includes('player.vimeo.com')) {
    return;
  }

  wrapper.insertAdjacentHTML(
    'afterend',
    '<div id="qlf_quiz_video_progress_bar_container" style="display:none;">\
    <div class="qlf_quiz_video_progress_track">\
      <div class="qlf_quiz_video_progress_inner">\
        <div class="qlf_quiz_video_progress_bar">\
          <div class="qlf_quiz_video_progress_text">0%</div>\
        </div>\
      </div>\
    </div>\
    <div class="qlf_quiz_video_progress_bar_bcgrnd"></div>\
    <p class="qlf-text-center qlf-font-bold" style="font-size: 16px; margin-top: 10px; margin-bottom: 0; padding: 0 20px; box-sizing: border-box;">\
        Deine Ergebnisse werden berechnet ...\
    </p>\
    </div>'
  );

  iframe.addEventListener('load', function () {
    const player = new Vimeo.Player(iframe);
    const progressBarContainer = document.querySelector('#qlf_quiz_video_progress_bar_container');
    const progressBar = progressBarContainer
      ? progressBarContainer.querySelector('.qlf_quiz_video_progress_bar')
      : null;
    const progressText = progressBarContainer
      ? progressBarContainer.querySelector('.qlf_quiz_video_progress_text')
      : null;
    const results = document.querySelector('.quiz-results');
    if (!progressBarContainer || !progressBar) return;

    const totalMs = 95_000;
    let started = false;
    let progressInterval = null;
    let startTime = null;
    let pausedTime = 0;
    let isPaused = false;

    function startTimeline() {
      if (started) return;
      started = true;

      progressBarContainer.style.display = '';
      progressBar.style.transition = 'none';
      progressBar.style.width = '0%';
      if (progressText) progressText.textContent = '0%';
      void progressBar.offsetWidth;

      progressBar.style.transition = 'width 1s ease-out';

      startTime = Date.now();
      updateProgress();
    }

    function updateProgress() {
      if (progressInterval) clearInterval(progressInterval);

      progressInterval = setInterval(function () {
        if (isPaused) return;

        const elapsed = Date.now() - startTime - pausedTime;
        let percentage;

        if (elapsed <= 30000) {
          // Erste 30 Sekunden: 0% bis 60%
          percentage = Math.min(60, Math.round((elapsed / 30000) * 60));
        } else {
          // Nach 30 Sekunden: 60% bis 100% über 65 Sekunden (statt 45)
          const remainingElapsed = elapsed - 30000;
          const remainingProgress = Math.min(40, Math.round((remainingElapsed / 65000) * 40));
          percentage = 60 + remainingProgress;
        }

        if (progressText) {
          progressText.textContent = percentage + '%';
        }

        progressBar.style.width = percentage + '%';

        if (percentage >= 100) {
          clearInterval(progressInterval);

          setTimeout(() => {
            progressBarContainer.style.transition = 'opacity 0.5s ease-out';
            progressBarContainer.style.opacity = '0';

            setTimeout(() => {
              progressBarContainer.style.display = 'none';
            }, 500);
          }, 500);

          if (results) {
            results.classList.add('is-visible');
            results.setAttribute('aria-hidden', 'false');
            if (typeof results.scrollIntoView === 'function') {
              results.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
          }
        }
      }, 100);
    }

    player.on('play', function () {
      if (!started) {
        startTimeline();
      } else if (isPaused) {
        pausedTime += Date.now() - pauseStartTime;
        isPaused = false;
      }
    });

    let pauseStartTime;
    player.on('pause', function () {
      if (started && !isPaused) {
        isPaused = true;
        pauseStartTime = Date.now();
      }
    });

    player.on('ended', function () {
      clearInterval(progressInterval);
    });
  });
});
